export default "__VITE_ASSET__3112da32__"